/**
 * This is a replica of React internal [shallowEqual]{@link https://github.com/facebook/react/blob/master/packages/shared/shallowEqual.js}
 * except it takes a mandatory third parameter.
 * @param {Object} objA
 * @param {Object} objB
 * @param {Function} compareByKey
 */
export function shallowEqual(objA, objB, comparePropsByKey) {
  if (Object.is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (let i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !comparePropsByKey(keysA[i], objA, objB)) {
      return false;
    }
  }

  return true;
}
